import { ReactNode } from 'react'
import { Link, usePage } from '@inertiajs/react'

interface SharedSAProps {
  current_super_admin?: { id: number; email: string; full_name: string } | null
  flash?: { notice?: string | null; alert?: string | null }
}

export default function SuperAdminLayout({ children }: { children: ReactNode }) {
  const { current_super_admin, flash } = usePage().props as unknown as SharedSAProps

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <nav className="bg-[#351E1D] min-h-14 flex flex-wrap items-center px-4 sm:px-6 py-2 gap-y-1 text-white">
        <Link href="/super_admin" className="font-semibold text-base mr-6">Pinnacle SuperAdmin</Link>
        <Link href="/super_admin" className="text-sm text-text-on-dark hover:text-white px-3 py-2">Dashboard</Link>
        <Link href="/super_admin/tenants" className="text-sm text-text-on-dark hover:text-white px-3 py-2">Tenants</Link>
        <Link href="/super_admin/pending_tenants" className="text-sm text-text-on-dark hover:text-white px-3 py-2">Pending</Link>
        <Link href="/super_admin/guides" className="text-sm text-text-on-dark hover:text-white px-3 py-2">Guides</Link>
        <Link href="/super_admin/guide_activity" className="text-sm text-text-on-dark hover:text-white px-3 py-2">Guide Activity</Link>
        <Link href="/super_admin/super_admins" className="text-sm text-text-on-dark hover:text-white px-3 py-2">Admins</Link>
        <Link href="/super_admin/email_setting" className="text-sm text-text-on-dark hover:text-white px-3 py-2">Email</Link>
        <Link href="/super_admin/billing" className="text-sm text-text-on-dark hover:text-white px-3 py-2">Billing</Link>
        <div className="ml-auto flex flex-wrap items-center gap-3 min-w-0">
          {current_super_admin && (
            <span className="text-xs text-text-on-dark break-all">{current_super_admin.email}</span>
          )}
          <Link
            href="/super_admin/sign_out"
            method="delete"
            as="button"
            className="text-sm text-text-on-dark hover:text-white border border-white/20 rounded px-3 py-1"
          >
            Sign out
          </Link>
        </div>
      </nav>

      {flash?.notice && (
        <div className="max-w-screen-2xl mx-auto px-6 pt-4">
          <div className="px-4 py-3 bg-[#15532E]/10 text-[#15532E] rounded-lg text-base">{flash.notice}</div>
        </div>
      )}
      {flash?.alert && (
        <div className="max-w-screen-2xl mx-auto px-6 pt-4">
          <div className="px-4 py-3 bg-[#ED1C24]/10 text-[#ED1C24] rounded-lg text-base">{flash.alert}</div>
        </div>
      )}

      <main className="max-w-screen-2xl mx-auto px-6 py-6">{children}</main>
    </div>
  )
}
